import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  all: [],
  categories: []
}

export default {
  state,
  getters,
  mutations,
  actions
}
